import { useEffect } from 'react'

import { readAppliedTenantIdentity } from '@/shared/lib/tenant/applied'
import { toTenantIdentity } from '@/shared/lib/tenant/identity'
import {
  APPLIED_IDENTITY_GLOBAL,
  tenantIdentityStyleVars
} from '@/shared/lib/tenant/identity-style'
import { reconcileTenantIdentity } from '@/shared/lib/tenant/reconcile'
import {
  readTenantIdentity,
  writeTenantIdentity
} from '@/shared/lib/tenant/snapshot'
import type { DigitalProduct } from '@/types/digitalProduct'

/**
 * Reconcilia o retrato gravado com a resposta confirmada: grava quando o
 * conteúdo difere, aplica só no primeiro boot absoluto (design D5). Nas demais
 * situações a correção é adiada — quem já tem a tela pintada não a vê mudar.
 */
export function useTenantIdentitySync(
  digitalProduct: DigitalProduct | undefined
): void {
  useEffect(() => {
    if (!digitalProduct || typeof window === 'undefined') return

    const host = window.location.host
    const incoming = toTenantIdentity(digitalProduct)
    const { write, apply } = reconcileTenantIdentity({
      applied: readAppliedTenantIdentity(),
      stored: readTenantIdentity(host),
      incoming
    })

    if (write) writeTenantIdentity(host, incoming)

    if (!apply) return

    const root = document.documentElement
    for (const [nome, valor] of Object.entries(
      tenantIdentityStyleVars(incoming)
    )) {
      root.style.setProperty(nome, valor)
    }

    // Para que a topbar e os demais leitores síncronos vejam o que está
    // pintado — uma verdade só.
    ;(window as unknown as Record<string, unknown>)[APPLIED_IDENTITY_GLOBAL] =
      incoming
  }, [digitalProduct])
}
